import { useLocation } from 'react-router';

import { routeToPageIdMapping } from 'src/app/routes/routeToPageIdMapping';
import { getPathWithoutLocalisation } from 'src/app/utils/getPathWithoutLocalisation';

export const usePage = () => {
  const { pathname } = useLocation();
  const unlocalisedPath = getPathWithoutLocalisation(pathname);

  return routeToPageIdMapping[unlocalisedPath || pathname];
};
